import { render } from "./support.vue?vue&type=template&id=3ca6956f&scoped=true"
import script from "./support.vue?vue&type=script&lang=js"
export * from "./support.vue?vue&type=script&lang=js"

import "./support.vue?vue&type=style&index=0&id=3ca6956f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ca6956f"]])

export default __exports__